// LIBRARIES //
import styled from 'styled-components';

// HELPERS //
import { colors } from 'helpers/ColorHelper';

const CardHeader = styled.div`
  background-color: ${colors.LIGHT_GRAY};
  text-align: center;
  width: 100%;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  padding-top: 12px;
  padding-bottom: 12px;
`;

export default CardHeader;
